import React from 'react';
import Layout from '../components/Layout';
import BuyOrderList from '../components/BuyOrderList';

/**
 * Página de listado de órdenes de compra
 * Utiliza el componente Layout para la estructura básica
 * y el componente BuyOrderList para mostrar la lista de órdenes
 */
function OrderList() {
  return (
    <Layout>
      <div>
        <BuyOrderList />
      </div>
    </Layout>
  );
}

export default OrderList;